import type { FC } from "react";
import { Separator } from "@components/UI/Separator";
import styles from "./ProductPreview.module.css";
import { useContactLensesStore } from "@/store";
import { useTranslation } from "@/i18n/useTranslation";
import { ProductData } from "@/types/config.types";

interface ProductPreviewProps {}

export const ProductPreview: FC<ProductPreviewProps> = () => {
  const { contactLensesData } = useContactLensesStore();
  const { t } = useTranslation();

  const products: ProductData[] = (() => {
    if (!contactLensesData) return [];

    const productList: ProductData[] = [];
    const uniqueIds = new Set<string>();

    // Aggiungi OD se esiste e non è già presente
    if (contactLensesData?.OD?.product) {
      const uniqueId =
        contactLensesData?.OD?.product?.catalogEntryIdentifier?.uniqueId;
      if (!uniqueIds.has(uniqueId)) {
        productList.push(contactLensesData.OD.product);
        uniqueIds.add(uniqueId);
      }
    }

    // Aggiungi OS solo se esiste e ha un uniqueId diverso
    if (contactLensesData?.OS?.product) {
      const uniqueId =
        contactLensesData.OS.product.catalogEntryIdentifier.uniqueId;
      if (!uniqueIds.has(uniqueId)) {
        productList.push(contactLensesData.OS.product);
        uniqueIds.add(uniqueId);
      }
    }

    return productList;
  })();

  return (
    <div className={styles.container}>
      {products.map((product, index) => (
        <div
          key={product.catalogEntryIdentifier.uniqueId}
          className={styles.item}
        >
          {product.description?.[0]?.fullImage && (
            <div className={styles.imageContainer}>
              <img
                src={product.description[0].fullImage}
                alt={product.description[0].name}
                className={styles.image}
              />
            </div>
          )}

          <div className={styles.content}>
            {products.length > 1 && (
              <p className={styles.name}>
                {index === 0 ? t("product.eye.right") : t("product.eye.left")}
              </p>
            )}
            <h3 className={styles.name}>{product.description?.[0]?.model}</h3>
            <p className={styles.quantity}>
              {product.packQuantity + " " + t("common.pack")}
            </p>
          </div>
          {index < products.length - 1 && <Separator />}
        </div>
      ))}
    </div>
  );
};
